import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { sectors, seoMeta } from '../data/pages'
import { useScrollAnimation } from '../hooks/useScrollAnimation'
import SEO from '../components/SEO'

export default function SectorsPage() {
  const { ref, isVisible } = useScrollAnimation()

  return (
    <>
      <SEO title={seoMeta.sectors.title} description={seoMeta.sectors.description} />

      <section className="relative bg-earth-900 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blossom-950 via-earth-900 to-prime-950" />
        <div className="container-wide section-padding relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <span className="badge-green mb-4">Sectors</span>
            <h1 className="text-display-1 font-bold text-white mb-4">Sectors We Serve</h1>
            <p className="text-earth-300 text-lg max-w-2xl">We focus on sectors where cleaning standards matter most — where presentation, hygiene and compliance directly affect the people who use the space.</p>
          </motion.div>
        </div>
      </section>

      <section className="section-padding-y section-padding bg-earth-50" ref={ref}>
        <div className="container-wide">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {sectors.map((sector, index) => (
              <motion.div key={sector.id} initial={{ opacity: 0, y: 30 }} animate={isVisible ? { opacity: 1, y: 0 } : {}} transition={{ delay: index * 0.1 }}
                className="group relative bg-white rounded-2xl overflow-hidden shadow-sm border border-earth-100 card-lift">
                <div className="aspect-[16/10] bg-gradient-to-br from-earth-200 to-earth-300 relative overflow-hidden">
                  <img src={sector.image} alt={sector.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
                  <div className="image-overlay" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-earth-900 mb-2 group-hover:text-blossom-700 transition-colors">{sector.title}</h3>
                  <p className="text-earth-500 text-sm leading-relaxed mb-4">{sector.description}</p>
                  <Link to="/contact" className="inline-flex items-center gap-1 text-sm font-medium text-blossom-600 group-hover:gap-2 transition-all">Get a sector quote <ArrowRight className="w-4 h-4" /></Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
